import React from 'react';
import i18n from '../i18n';

// Without a boundary, any error thrown while rendering unmounts the whole
// app and leaves a blank page. Show what failed and offer a reload instead.
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const reload = this.props.onReload || (() => window.location.reload());
    return (
      <div
        role="alert"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          background: '#111113',
          color: '#cbd5e1',
          flexDirection: 'column',
          gap: '16px',
          padding: '24px',
          textAlign: 'center',
        }}
      >
        <h1 style={{ fontSize: '1.25rem', margin: 0, color: '#fff' }}>
          {i18n.t('common:errorBoundary.title')}
        </h1>
        <p style={{ fontSize: '0.875rem', margin: 0, maxWidth: '36rem' }}>
          {i18n.t('common:errorBoundary.body')}
        </p>
        <code style={{ fontSize: '0.75rem', opacity: 0.7, maxWidth: '36rem', wordBreak: 'break-word' }}>
          {String(error?.message || error)}
        </code>
        <button type="button" className="btn btn-primary" onClick={reload}>
          {i18n.t('common:errorBoundary.reload')}
        </button>
      </div>
    );
  }
}

export default AppErrorBoundary;
